import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import type { QueriesResults, QueryFunctionContext, UseQueryOptions } from "@tanstack/react-query";
import { useQueries } from "@tanstack/react-query";
import { homePageQueryKeys } from "../services/queries/queryKeyFactory";
import type { AssetsCountDto, ListItemDto } from "../types/dto";
import { toListAssetsDto } from "../utils/lists/toListAssetsDto";

const createQueryOptions = (list: ListItemDto): UseQueryOptions => ({
    queryKey: homePageQueryKeys.listAssetsCount(list.listId),
    retry: false,
    throwOnError: true,
    queryFn({ signal }: QueryFunctionContext): Promise<AssetsCountDto> {
        const queryParams = toListAssetsDto(list);

        return salesApiService.home.fetchListsAssetsCount(queryParams, {
            cancellation: signal,
        });
    },
});

const useListsAssetsCountQueries = (lists: readonly ListItemDto[]): QueriesResults<AssetsCountDto[]> => {
    return useQueries({
        queries: lists.map(createQueryOptions)
    });
};

export default useListsAssetsCountQueries;
